// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"205":"985372ee","551":"a48333ac"}[chunkId] + ".chunk.js";
};